// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3TsM6","footer":"Form_footer__1yBFp"};